import { IconCircleCheckFilled } from "@tabler/icons-react";
import { Flex, Text } from "@mantine/core";

import styles from "./CompletionBadge.module.css";

interface CompletionBadgeProps {
  text: string;
}

export function CompletionBadge({ text }: CompletionBadgeProps) {
  return (
    <Flex className={styles.badge} data-testid="completion-badge">
      <IconCircleCheckFilled
        className={styles.icon}
        data-testid="completion-badge-icon"
        size={16}
      />
      <Text className={styles.copy}>{text}</Text>
    </Flex>
  );
}
